import * as React from 'react'
import Typography from '@mui/material/Typography'
export default function StatusText({ status }) {
    return (
        <Typography variant="body2" backgroundColor={status === 'Draft' ? 'yellow' :
            status === 'Submitted' ? 'orange' :
                status === 'Approved' ? 'green' : 'red'}
            sx={{
                color: `${status === 'Draft' ? 'black' :
                    status === 'Submitted' ? 'white' :
                        status === 'Approved' ? 'darkgreen' : 'darkred'}`,
                borderRadius: '10px', padding: '2px 4px', textAlign: 'center', fontSize: 20,
                width: '100%'
            }}>
            Status : {status}
        </Typography>
    )
}
